export function individualFunc() {
  document.querySelectorAll('.js-individual').forEach(initMarquee);
}

function initMarquee(ul) {
  if (!ul || ul.__marqueeInit) return;
  ul.__marqueeInit = true;

  if (ul.parentElement?.classList.contains('c-individual-heading-img__track')) {
    const oldMarquee = ul.parentElement.parentElement;
    oldMarquee.parentElement.insertBefore(ul, oldMarquee);
    oldMarquee.remove();
  }

  const marquee = document.createElement('div');
  marquee.className = 'c-individual-heading-img__marquee';
  const track = document.createElement('div');
  track.className = 'c-individual-heading-img__track';

  ul.parentNode.insertBefore(marquee, ul);
  marquee.appendChild(track);
  track.appendChild(ul);

  if (ul.children.length === 1) {
    ul.appendChild(ul.children[0].cloneNode(true));
  }

  const spacer = document.createElement('i');
  spacer.className = 'c-individual-heading-img__spacer';
  track.appendChild(spacer);

  const clone = ul.cloneNode(true);
  clone.setAttribute('aria-hidden', 'true');
  track.appendChild(clone);

  const waitImages = (root) =>
    Promise.all(
      Array.from(root.querySelectorAll('img')).map(img =>
        img.complete
          ? Promise.resolve()
          : new Promise(r => {
              img.addEventListener('load', r, { once: true });
              img.addEventListener('error', r, { once: true });
            })
      )
    );

  const getPxPerSec = () => {
    const isSp = window.matchMedia('(max-width: 768px)').matches;
    const base = Number(ul.dataset.speed) || 60;
    const sp   = Number(ul.dataset.speedSp);
    const pc   = Number(ul.dataset.speedPc);
    return isSp ? (sp || base) : (pc || base + 20);
  };

  const syncVars = () => {
    const ulGap = parseFloat(getComputedStyle(ul).gap) || 0;
    marquee.style.setProperty('--gap', ulGap + 'px');
    marquee.style.setProperty('--eps', '1px');
  };

  const measure = () => {
    const base = ul.getBoundingClientRect().width;
    const dur  = Math.max(6, base / getPxPerSec());
    marquee.style.setProperty('--w',  base + 'px');
    marquee.style.setProperty('--dur', dur + 's');
  };

  Promise.all([waitImages(ul), waitImages(clone)]).then(() => {
    syncVars();
    requestAnimationFrame(() => {
      measure();
    });
  });

  let t;
  const onResize = () => {
    clearTimeout(t);
    t = setTimeout(() => { syncVars(); measure(); }, 150);
  };
  window.addEventListener('resize', onResize);

  if (window.matchMedia('(hover:hover)').matches) {
    marquee.addEventListener('mouseenter', () => { track.style.animationPlayState = 'paused'; });
    marquee.addEventListener('mouseleave', () => { track.style.animationPlayState = 'running'; });
  }

  ul.__marquee = { marquee, track, spacer, clone, onResize };
}
